import gql from "graphql-tag";

export default gql`
  mutation AdminDeletePermitPass($id: Int!) {
    admin_deletePermitPass(id: $id) {
      id
    }
  }
`;
